/**
 * Server → client combat events (GDD §9.3 CombatEvent). They only drive
 * effects: scores, meters and hitstun travel in the replicated state, and the
 * server sends each event right after the patch that contains its outcome.
 */
export const COMBAT_MESSAGE = "combat";

export type CombatEvent =
  | {type:'tentacleHit';caster:string;x:number;y:number;z:number;fx:number;fz:number;length:number}
  | {type:'summonHit';id:string;dead:boolean}
  | {type:"restore";caster:string;amount:number;resource:"hp"|"slam"}
  | { type:"photo"; caster:string; x:number; y:number; z:number; gain:number }
  | { type:"bomb"; caster:string; x:number; y:number; z:number; radius:number }
  /** One of Maria Antonietta's brioches went off. */
  | { type:"brioche"; caster:string; x:number; y:number; z:number; radius:number }
  | { type:"airstrike"; caster:string; id:number }
  | { type:"grab"; caster:string; target:string }
  | { type: "damage"; target: string; amount: number }
  | { type: "ko"; target: string; attacker: string; x: number; y: number; z: number }
  | { type: "respawn"; target: string }
  | { type: "counter" | "purify" | "bounce"; caster: string; x: number; y: number; z: number }
  | { type: "move"; caster: string; action: number; x: number; y: number; z: number; fx: number; fz: number }
  | {
      type: "hit";
      attacker: string;
      target: string;
      /** `Action` of the attack that connected. */
      action: number;
      /** Hits taken by the target in this combo, this one included. */
      combo: number;
    }
  | {
      /** A Super Slam started winding up; `id` identifies it in the events that follow. */
      type: "slamStart";
      id: number;
      caster: string;
    }
  | {
      type: "slam";
      id: number;
      caster: string;
      targets: string[];
      points: number;
      /** Server tick of the resolution: equal ticks mean simultaneous Super Slams. */
      tick: number;
    }
  | {
      /** Someone picked up an object thrown by the crowd (`PickupKind`). */
      type: "pickup";
      who: string;
      kind: number;
    }
  | {
      /** An object of the map broke (or a thrown one shattered) at (x, y, z). */
      type: "propBreak";
      id: string;
      x: number;
      y: number;
      z: number;
    }
  | {
      /** An object of the map took a hit and holds. */
      type: "propHit";
      id: string;
    }
  | {
      /** Someone pulled the lever of the trap. */
      type: "lever";
      who: string;
    }
  | {
      /** The applause meter filled: the crowd throws `count` objects. */
      type: "cheer";
      count: number;
    }
  | {
      /** Interrupted before going off (hit by another Super Slam, fell off): meter refunded. */
      type: "slamCancel";
      id: number;
      caster: string;
    };
